import { render, staticRenderFns } from "./bot-training.vue?vue&type=template&id=7d6cda7b&scoped=true&"
import script from "./bot-training.vue?vue&type=script&lang=js&"
export * from "./bot-training.vue?vue&type=script&lang=js&"
import style0 from "./bot-training.vue?vue&type=style&index=0&id=7d6cda7b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d6cda7b",
  null
  
)

export default component.exports